import React from 'react'
import storage from 'util/storage'

import logo from 'assets/integrations/shopify.png'

import NavigatableIntegrationWidgetCard from '../NavigatableIntegrationWidgetCard'
import ShopifyDetail from './ShopifyDetail'
import ShopifyIndex from './ShopifyIndex'

import { styles } from './styles'

export default function ShopifyView({
  id,
  doHideCard,
  data,
  isLoading,
  name,
  onReload,
  integration,
  fetchEvents,
  timelineEventsByDay,
  fetchOrders,
  fetchShop,
  showCard,
}) {
  if (!storage.get('showShopifyV2') || !showCard) return null

  return (
    <div css={styles.base}>
      <NavigatableIntegrationWidgetCard
        data={data}
        detailComponent={ShopifyDetail}
        doHideCard={doHideCard}
        image={logo}
        indexComponent={ShopifyIndex}
        isLoading={isLoading}
        title={name || 'Shopify'}
        persistenceKey={`shopify-${id}`}
        refreshable
        onRefresh={onReload}
        integration={integration}
        fetchEvents={fetchEvents}
        timelineEventsByDay={timelineEventsByDay}
        fetchOrders={fetchOrders}
        fetchShop={fetchShop}
        hidePadding
      />
    </div>
  )
}
